import React, { useRef } from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { SKILL_CHIP } from './constants';

export const ApplyDialog = ({ applyJob, onClose, selectedFile, setSelectedFile, applying, onSubmit, onRequestAedt }) => {
  const fileRef = useRef(null);
  return (
    <Dialog open={!!applyJob} onOpenChange={onClose}>
      <DialogContent style={{ background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, maxWidth: 480 }}>
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Cabinet Grotesk' }}>Apply to {applyJob?.title}</DialogTitle>
        </DialogHeader>
        {applyJob && (
          <div>
            <p style={{ fontSize: '0.875rem', color: '#64748B', marginBottom: '1rem', lineHeight: 1.6 }}>
              {applyJob.location || 'Remote'} &middot; {applyJob.job_type} &middot; {applyJob.experience_years || 0}+ years
            </p>

            {(applyJob.required_skills || []).length > 0 && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.375rem', marginBottom: '1.25rem' }}>
                {applyJob.required_skills.map(s => (
                  <span key={s} style={SKILL_CHIP}>{s}</span>
                ))}
              </div>
            )}

            <div data-testid="aedt-notice" style={{ padding: '0.875rem 1rem', borderRadius: 10, background: 'rgba(30,104,255,0.05)', border: '1px solid rgba(30,104,255,0.15)', marginBottom: '1.25rem' }}>
              <p style={{ fontSize: '0.75rem', color: '#334155', lineHeight: 1.6, margin: 0 }}>
                <strong style={{ color: '#0076A3' }}>AI is used to help evaluate applications.</strong> This employer may use an Automated Employment Decision Tool to screen and score candidates (NYC Local Law 144). A recruiter reviews every candidate — AI does not make the final decision.
                {' '}
                <a href="/ai-transparency" target="_blank" rel="noopener noreferrer" style={{ color: '#0076A3', fontWeight: 600 }}>Learn how AI is used</a>.
              </p>
              <button
                type="button"
                data-testid="request-alternative-button"
                onClick={onRequestAedt}
                style={{ marginTop: '0.5rem', background: 'none', border: 'none', padding: 0, color: '#0076A3', fontSize: '0.75rem', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}
              >
                Request an alternative process or accommodation
              </button>
            </div>

            <div style={{ marginBottom: '1.25rem' }}>
              <label style={{ display: 'block', fontSize: '0.8125rem', fontWeight: 600, color: '#002A38', marginBottom: '0.5rem' }}>Upload Your Resume *</label>
              <div
                data-testid="apply-resume-dropzone"
                onClick={() => fileRef.current?.click()}
                style={{ border: '2px dashed #CBD5E1', borderRadius: 12, padding: '1.5rem', textAlign: 'center', cursor: 'pointer', background: '#FAF7F2', transition: 'border-color 0.2s' }}
              >
                <input ref={fileRef} type="file" accept=".pdf,.docx,.txt" style={{ display: 'none' }}
                  onChange={e => setSelectedFile(e.target.files[0] || null)} />
                {selectedFile ? (
                  <div>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ margin: '0 auto 0.5rem' }}>
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
                    </svg>
                    <p style={{ fontSize: '0.875rem', fontWeight: 600, color: '#059669' }}>{selectedFile.name}</p>
                    <p style={{ fontSize: '0.6875rem', color: '#94A3B8', marginTop: '0.25rem' }}>Click to change file</p>
                  </div>
                ) : (
                  <div>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ margin: '0 auto 0.5rem' }}>
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                    </svg>
                    <p style={{ fontSize: '0.875rem', color: '#64748B' }}>Click to upload resume</p>
                    <p style={{ fontSize: '0.6875rem', color: '#94A3B8' }}>PDF, DOCX, or TXT</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} style={{ borderRadius: 10 }}>Cancel</Button>
          <Button data-testid="submit-application-button" onClick={onSubmit} disabled={applying || !selectedFile} style={{ background: '#0076A3', color: '#fff', borderRadius: 999, fontWeight: 600 }}>
            {applying ? 'Submitting...' : 'Submit Application'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
